import * as types from "./actionTypes";
import { MentorToken } from "../../Auto/Interfaces/MentorToken";
import * as sessionsService from "../../Auto/ApiDefinitions/MentorSessionsService";
import { MentorAppThunk } from "./AppThunk";
import { DateTime } from "luxon";
import { apiErrorOccurred } from "./sharedActions";

export function refreshMentorToken(): MentorAppThunk {
    return function (dispatch, getState) {
        const { mentorAccess } = getState();
        return sessionsService
            .refreshMentorToken(mentorAccess.token)
            .then((newToken) => {
                dispatch(refreshMentorTokenComplete(newToken));
            })
            .catch((error) => {
                dispatch(apiErrorOccurred(error, "Failed to refresh mentor token"));
            });
    };
}

function refreshMentorTokenComplete(newToken: MentorToken) {
    return {
        type: types.MENTOR_TOKEN_REFRESHED as typeof types.MENTOR_TOKEN_REFRESHED,
        newToken,
    };
}

export function refreshMentorTokenIfUpdated(): MentorAppThunk {
    return function (dispatch, getState) {
        var currentIso = getState().mentorAccess.expiration.toISO();
        var storageIso = DateTime.fromISO(localStorage.getItem("expiration") ?? DateTime.utc().toISO()).toISO();

        if (currentIso !== storageIso) {
            dispatch(refreshMentorTokenIfUpdatedComplete());
        }
    };
}

function refreshMentorTokenIfUpdatedComplete() {
    return {
        type: types.MENTOR_TOKEN_REFRESH_NEEDED as typeof types.MENTOR_TOKEN_REFRESHED,
    };
}

export function expireMentorToken(): MentorAppThunk {
    return function (dispatch, getState) {
        dispatch(clearMentorToken());
    };
}

function clearMentorToken() {
    return {
        type: types.MENTOR_TOKEN_EXPIRED as typeof types.MENTOR_TOKEN_EXPIRED,
    };
}

export type MentorActions =
    | ReturnType<typeof refreshMentorTokenComplete>
    | ReturnType<typeof clearMentorToken>
    | ReturnType<typeof refreshMentorTokenIfUpdatedComplete>;
